import React, {useEffect, useState} from 'react'
import styles from "../Pages/Corpus/corpus.module.css"
import "../App.css"
import UnitStyles from '../Pages/MilUnit/MilUnit.module.css'
import BattalionList from '../Pages/Battalion/BattalionList'
import CompanyList from '../Pages/Company/CompanyList'
import PlatoonList from '../Pages/Platoon/PlatoonList'

export default function MillUnitList({millUnits, corpusNumber, battalions, companies,platoons, changeMilUnit, deleteBattalion}) {
    const [filteredUnits, setFilteredUnits] = useState([])
    const [choosenUnit, setChosenUnit] = useState()
    const [chosenBattalion, setChosenBattalion] = useState()
    const [choosenCompany, setChosenCompany] = useState()

    useEffect(() => {
        setFilteredUnits(millUnits.filter(el => el.unit_corpus === corpusNumber))
    }, [millUnits])

  return (
      <div className={UnitStyles["units-main-div"]}>
          <div className={UnitStyles["unit-list"]}>
              <ol className='border-t border-black/40'>
                  <li className={styles["corpus-list-item"]}>
                      <p className='per3 start'>Զորամաս</p>
                  </li>
                  {filteredUnits?.map((el, index) => {
                      return <li key={index} className={styles["corpus-list-item"]} onClick={() => choosenUnit !== el._id ? setChosenUnit(el._id) : setChosenUnit(null)}>
                              <p className='per3 start'>{el?.unit_number + " " + el.unit_name}  ({el?.unit_close_number})</p>
                              {battalions && choosenUnit === el._id && <BattalionList battalions={battalions.filter(battalion => battalion.battalion_unit._id === el._id)} changeMilUnit={changeMilUnit} deleteBattalion={deleteBattalion} />}
                              {!battalions && choosenUnit === el._id && <ol onClick={e => e.stopPropagation()}>
                                          <li className={styles["corpus-list-item"]}>
                                              <p className='per3 start'>Գումարտակի համար/Անվանում</p>
                                          </li>
                                          {el.unit_battalions?.map((battalion, index) => {
                                              return <li key={index} className={styles["corpus-list-item"]} onClick={() => chosenBattalion !== battalion._id ? setChosenBattalion(battalion._id) : setChosenBattalion(null)}>
                                                        <p className='per3 start'>{`${battalion?.battalion_number ? battalion?.battalion_number + " " : ""}${battalion?.battalion_name ? battalion?.battalion_name : ""}`}</p>
                                                        {companies && chosenBattalion === battalion._id && <CompanyList companies={companies.filter(company => company.company_battalion._id === battalion._id)} chnageCompany={changeMilUnit} deleteCompany={deleteBattalion} />}
                                                        {!companies && chosenBattalion === battalion._id && <ol onClick={e => e.stopPropagation()}>
                                                            <li className={styles["corpus-list-item"]}>
                                                                <p className='per4 start'>Վաշտի համար</p>
                                                            </li>
                                                            {el.unit_companies?.map((company, index) => {
                                                                return <li key={index} className={styles["corpus-list-item"]} onClick={() => choosenCompany !== company._id ? setChosenCompany(company._id) : setChosenCompany(null)}>
                                                                        <p className='per4 start'>{company?.company_number}</p>
                                                                        {platoons && choosenCompany === company._id && <PlatoonList platoons={platoons?.filter(platoon => platoon.platoon_company._id === company._id)} chnageCompany={changeMilUnit} deleteCompany={deleteBattalion} />}
                                                                    </li>
                                                            })}
                                                        </ol>}
                                                  </li>
                                          })}
                                 </ol>}
                          </li>
                  })}
              </ol>
          </div>
      </div>
    )
}
